<template>
	<div class="content" style="height: 100%;">
		<!-- <HeaderPublic /> -->
		<section class="section section--intro" id="intro">
			<div class="section__content section__content--fluid-width section__content--intro">
				<div class="intro">
					<div class="intro__content">
						<div class="intro__title">{{translate(locale.name)}}</div>
						<div class="intro__buttons intro__buttons--right">

							<a @click="login" class="btn btn--orange-bg">{{translate(locale.login)}}</a>
						</div>
					</div>
				</div>
			</div>

		</section>
	</div>
</template>

<script>
		export default {
		created() {
		},
		data() {
			return {
			}
		},
		methods: {
			login_single_id() {
				this.$http.get(this.config.api + "/user/get_login").then(res => {
					if (res.body.status == 'success') {
						window.location.replace(res.body.data.redirect_url);
					}
				})
			},
			login() {
				if (String(this.$store.state.authentication.authToken).length < 64 || this.$store.state.authentication.authToken == null) {
					this.login_single_id();
				} else {
					this.$http.get(this.config.api + "/user/authenticate").then(res => {

						if (res.body.status == 'success') {
							this.$router.push("/");
						} else {
							this.login_single_id();
						}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.footer-menu {
		color: #FFF !important;
	}
	.footer-menu:hover {
		color: #FFF !important;
	}
	.section {
		width: 100%;
		height: auto;
		float: left;
		clear: both;
		background-color: #FFF;
	}

	/* BLOCK MODIFIER - section--page */
	.section--page-top {
		padding-top: 80px;
	}

	.section--page-bottom {
		padding-bottom: 80px;
	}

	/* ELEMENT - section__content */
	.section__content {
		clear: both;
	}

	/* ELEMENT MODIFIER section__content  */
	.section__content--fix-width {
		width: 1240px;
		margin: auto;
		clear: both;
	}

	.section__content--fluid-width {
		width: 80%;
		margin: auto;
		clear: both;
	}

	.section__content--padding {
		padding: 100px 0;
	}

	/* ELEMENT - section__title */
	.section__title {
		font-size: 48px;
		padding: 0 0 40px 0;
		font-weight: 700;
		line-height: 52px;
	}

	/* ELEMENT MODIFIER section__title  */
	.section__title--centered {
		width: 100%;
		text-align: center;
		position: relative;
	}

	.section__title--centered:after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		top: 80%;
		margin: auto;
		width: 50px;
		height: 1px;
		background: #454545;
	}

	/* ELEMENT - section__description */
	.section__description {
		font-size: 18px;
		line-height: 32px;
	}

	/* ELEMENT MODIFIER section__description  */
	.section__description--centered {
		width: 60%;
		margin: auto;
		text-align: center;
		padding: 0 0 80px 0;
	}

	/*===============================================*/
	/* 5. GRID 	 						 */
	/*===============================================*/

	/* BLOCK - grid */
	.grid {
		width: 100%;
		float: left;
		clear: both;
	}

	.grid__item--padding {
		background-color: #f7f8f9;
	}

	.grid__item--centering {
		text-align: center;
		display: -webkit-box;
		display: -webkit-flex;
		display: -moz-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-flex-align: center;
		-ms-flex-align: center;
		-webkit-align-items: center;
		align-items: center;
	}

	/* -----------------------------------------------------  */
	/* ELEMENT grid__item BASED ON BLOCK MODIFIER grid--2col  */
	.grid--2col .grid__item {
		float: left;
		margin-right: 80px;
		margin-bottom: 80px;
		/* full width - space between cols / number of cols */
		width: calc((100% - 80px) / 2);
	}

	.grid--2col .grid__item--padding {
		/* full width - space between cols - padding * nr of paddings / number of cols */
		width: calc((100% - 80px - 20px * 4) / 2);
		padding: 20px;
	}

	.grid .grid__item:last-child,
	.grid--2col .grid__item:nth-child(2n+2) {
		float: right;
		margin-right: 0px;
	}

	/* -----------------------------------------------------  */
	/* ELEMENT grid__item BASED ON BLOCK MODIFIER grid--3col  */
	.grid--3col .grid__item {
		float: left;
		margin-right: 80px;
		margin-bottom: 80px;
		/* full width - space between cols * nr of inner spaces / number of cols */
		width: calc((100% - 80px * 2) / 3);
	}

	.grid--3col .grid__item.grid__item--padding {
		/* full width - space between cols * nr of inner spaces - padding * nr of paddings / number of cols */
		width: calc((100% - 80px * 2 - 20px * 6) / 3);
		padding: 20px;
	}

	.grid--3col .grid__item--x2 {
		/*(      one grid item    ) * 2 + space between cols */
		width: calc((((100% - 80px * 2) / 3) * 2) + 80px);
	}

	.grid--3col .grid__item--x2.grid__item--padding {

		/*   (    one grid item with padding  ) * 2 + space between cols + padding */
		width: calc((((100% - 80px * 2 - 20px * 6) / 3) * 2) + 80px + 20px * 2);
		padding: 20px;
	}

	.grid--3col .grid__item:nth-child(3n+3) {
		float: right;
		margin-right: 0px;
	}

	/* -----------------------------------------------------  */
	/* ELEMENT grid__item BASED ON BLOCK MODIFIER grid--4col  */
	.grid--4col .grid__item {
		float: left;
		margin-right: 80px;
		margin-bottom: 80px;
		/* full width - space between cols * nr of inner spaces / number of cols */
		width: calc((100% - 80px * 3) / 4);
	}

	.grid--4col .grid__item.grid__item--padding {
		/* full width - space between cols * nr of inner spaces - padding * nr of paddings / number of cols */
		width: calc((100% - 80px * 3 - 20px * 8) / 4);
		padding: 20px;
	}

	.grid--4col .grid__item--x3 {
		/*(      one grid item    ) * 3 + space between cols */
		width: calc((((100% - 80px * 3) / 4) * 3) + 80px * 2);
	}

	.grid--4col .grid__item--x3.grid__item--padding {

		/*   (    one grid item with padding  ) * 3 + space between cols + padding */
		width: calc((((100% - 80px * 3 - 20px * 8) / 4) * 3) + 80px * 2 + 20px * 4);
		padding: 20px;
	}

	.grid--4col .grid__item:nth-child(4n+4) {
		float: right;
		margin-right: 0px;
	}

	/* -----------------------------------------------------  */
	/* ELEMENT grid__item BASED ON BLOCK MODIFIER grid--5col  */
	.grid--5col .grid__item {
		float: left;
		margin-right: 80px;
		margin-bottom: 30px;
		/* full width - space between cols * nr of inner spaces / number of cols */
		width: calc((100% - 80px * 4) / 5);
	}

	.grid--5col .grid__item.grid__item--padding {
		/* full width - space between cols * nr of inner spaces - padding * nr of paddings / number of cols */
		width: calc((100% - 80px * 4 - 20px * 10) / 5);
		padding: 20px;
	}

	.grid--5col .grid__item--x2 {
		/*(      one grid item    ) * 2 + space between cols */
		width: calc((((100% - 80px * 4) / 5) * 2) + 80px);
	}

	.grid--5col .grid__item--x2.grid__item--padding {

		/*   (    one grid item with padding  ) * 2 + space between cols + padding */
		width: calc((((100% - 80px * 4 - 20px * 10) / 5) * 2) + 80px + 20px * 2);
		padding: 20px;
	}

	.grid--5col .grid__item--x3 {
		/*(      one grid item    ) * 3 + space between cols */
		width: calc((((100% - 80px * 4) / 5) * 3) + 80px * 2);
	}

	.grid--5col .grid__item--x3.grid__item--padding {

		/*   (    one grid item with padding  ) * 3 + space between cols + padding */
		width: calc((((100% - 80px * 4 - 20px * 10) / 5) * 3) + 80px * 2 + 20px * 4);
		padding: 20px;
	}

	.grid--5col .grid__item--x4 {
		/*(      one grid item    ) * 4 + space between cols */
		width: calc((((100% - 80px * 4) / 5) * 4) + 80px * 3);
	}

	.grid--5col .grid__item--x4.grid__item--padding {

		/*   (    one grid item with padding  ) * 4 + space between cols + padding */
		width: calc((((100% - 80px * 4 - 20px * 10) / 5) * 4) + 80px * 3 + 20px * 6);
		padding: 20px;
	}

	.grid--5col .grid__item:nth-child(5n+5) {
		float: right;
		margin-right: 0px;
	}

	/* -----------------------------------------------------  */
	/* ELEMENT grid__item BASED ON BLOCK MODIFIER grid--6col  */
	.grid--6col .grid__item {
		float: left;
		margin-right: 80px;
		margin-bottom: 80px;
		/* full width - space between cols * nr of inner spaces / number of cols */
		width: calc((100% - 80px * 5) / 6);
	}

	.grid--6col .grid__item.grid__item--padding {
		/* full width - space between cols * nr of inner spaces - padding * nr of paddings / number of cols */
		width: calc((100% - 80px * 5 - 20px * 12) / 6);
		padding: 20px;
	}

	.grid--6col .grid__item--x2 {
		/*(      one grid item    ) * 2 + space between cols */
		width: calc((((100% - 80px * 5) / 6) * 2) + 80px);
	}

	.grid--6col .grid__item--x2.grid__item--padding {

		/*   (    one grid item with padding  ) * 2 + space between cols + padding */
		width: calc((((100% - 80px * 5 - 20px * 12) / 6) * 2) + 80px + 20px * 2);
		padding: 20px;
	}

	.grid--6col .grid__item--x3 {
		/*(      one grid item    ) * 3 + space between cols */
		width: calc((((100% - 80px * 5) / 6) * 3) + 80px * 2);
	}

	.grid--6col .grid__item--x3.grid__item--padding {

		/*   (    one grid item with padding  ) * 3 + space between cols + padding */
		width: calc((((100% - 80px * 5 - 20px * 12) / 6) * 3) + 80px * 2 + 20px * 4);
		padding: 20px;
	}

	.grid--6col .grid__item--x4 {
		/*(      one grid item    ) * 4 + space between cols */
		width: calc((((100% - 80px * 5) / 6) * 4) + 80px * 3);
	}

	.grid--6col .grid__item--x4.grid__item--padding {

		/*   (    one grid item with padding  ) * 4 + space between cols + padding */
		width: calc((((100% - 80px * 5 - 20px * 12) / 6) * 4) + 80px * 3 + 20px * 6);
		padding: 20px;
	}

	.grid--6col .grid__item--x5 {
		/*(      one grid item    ) * 5 + space between cols */
		width: calc((((100% - 80px * 5) / 6) * 5) + 80px * 4);
	}

	.grid--6col .grid__item--x5.grid__item--padding {

		/*   (    one grid item with padding  ) * 5 + space between cols + padding */
		width: calc((((100% - 80px * 5 - 20px * 12) / 6) * 5) + 80px * 4 + 20px * 8);
		padding: 20px;
	}

	.grid--6col .grid__item:nth-child(6n+6) {
		float: right;
		margin-right: 0px;
	}

	.grid__item--floated-right {
		float: right !important;
		margin-right: 0px !important;
	}

	/* 5.1 GRID ELEMENTS   */
	/*===============================================*/

	/* ELEMENT  grid__title  */
	/* --------------------  */
	.grid__title {
		font-size: 24px;
		font-weight: 400;
		padding: 0 0 20px 0;
		margin: 0px;
	}

	.grid__title span {
		font-weight: 700;
	}

	/* ELEMENT  grid__text  */
	/* --------------------  */
	.grid__text {
		padding-bottom: 20px;
		line-height: 26px;
	}

	.grid__text span {
		font-weight: 700;
	}

	/* ELEMENT  grid__more  */
	/* --------------------  */
	.grid__more {
		font-weight: 400;
		font-size: 14px;
		padding: 0 0 0 0;
		display: inline-block;
	}

	/* ELEMENT grid__list  */
	/* --------------------  */
	.grid__list {
		list-style: none;
		padding: 0px;
		margin: 0px;
	}

	.grid__list li {
		list-style: none;
		padding: 5px 0;
		margin: 0px;
		line-height: 22px;
	}

	/* ELEMENT grid__image  */
	/* --------------------  */
	.grid__image {
		width: 100%;
	}

	.grid__image img {
		display: block;
		max-width: 100%;
	}

	.grid__image--right img {
		float: right;
	}

	.grid__image--left img {
		float: left;
	}


	/*===============================================*/
	/*  6. BUTTONS	 			 */
	/*===============================================*/
	.btn {
		padding: 12px 40px;
		margin: 0 20px 0 0;
		font-size: 14px;
		letter-spacing: 0.5px;
		font-weight: 400;
		-webkit-border-radius: 25px;
		-moz-border-radius: 25px;
		border-radius: 25px;
		-webkit-transition: all 0.3s ease;
		-moz-transition: all 0.3s ease;
		transition: all 0.3s ease;
		cursor: pointer;
	}

	.btn--blue-bg {
		color: #fff;
		background-color: #199d48;
		border: 2px #199d48 solid;
	}

	.btn--blue-bg:hover {
		background-color: transparent;
		color: #199d48;
	}

	.btn--play {

		background-position: 90% 50%;
		background-repeat: no-repeat;
		padding-right: 60px;
	}

	.btn--play:hover {
		background-position: 92% 50%;
	}

	.btn--blue-border {
		color: #199d48;
		border: 1px #199d48 solid;
	}

	.btn--blue-border:hover {
		background-color: #199d48;
		color: #fff;
	}

	.btn--green-bg {
		color: #fff;
		background-color: #28e180;
		border: 2px #28e180 solid;
	}

	.btn--green-bg:hover {
		color: #28e180;
		background-color: transparent;
	}

	.btn--green-border {
		color: #28e180;
		border: 1px #28e180 solid;
	}

	.btn--green-border:hover {
		background-color: #28e180;
		color: #fff;
	}

	.btn--orange-bg {
		color: #fff !important;
		background-color: #199d48;
		border: 2px #199d48 solid;
		font-family: "Open Sans", "Hanuman", sans-serif;
		font-weight: bold;
	}

	.btn--orange-bg:hover {
		color: #FFF;
		background-color: transparent;
	}

	.btn--orange-border {
		color: #199d48;
		border: 1px #199d48 solid;
	}

	.btn--orange-border:hover {
		background-color: #199d48;
		color: #fff;
	}

	.section--intro {
		width: 100%;
		height: 100%;
		background-color: #353690;
		background: -webkit-linear-gradient(60deg, #353690 0, #0cf);
		background: linear-gradient(60deg, #353690 0, #0cf);
		position: relative;
		overflow: hidden;
	}

	.section__content--intro {
		height: 100%;
	}

	.intro {
		width: 100%;
		float: left;
		padding: 15% 0 0 0;
		position: relative;
		z-index: 777;
	}

	.intro__content {
		width: 100%;
		text-align: center;
	}

	.intro__title {
		padding: 0 0 20px 0;
		color: #fff;
		font-size: 36px;
		line-height: 80px;
		font-family: "Open Sans", "Moul", sans-serif;
	}

	.intro__title span {
		font-weight: 700;
	}

	.intro__subtitle {
		padding: 0 0 40px 0;
		font-size: 25px;
		line-height: 50px;
		color: #fff;
		letter-spacing: 0.4px;
	}

	.intro__description {
		padding: 0 0 40px 0;
		font-size: 20px;
		color: #df86f9;
	}

	.intro__description span {
		font-weight: 700;
		color: #199d48;
	}

	.intro__buttons {
		padding: 20px 0 0 0;
	}

	.intro__buttons--centered {
		width: 100%;
		clear: both;
		text-align: center;
	}

	.intro__buttons--left {
		width: 100%;
		clear: both;
		text-align: left;
	}

	svg.svg-intro-bottom {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 50%;
		z-index: 666;
	}

	svg.svg-intro-bottom-2 {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 65%;
		z-index: 555;
	}

	svg.svg-intro-bottom-3 {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 100%;
		z-index: 111;
	}

	.intro-animation {
		width: 50%;
		height: 70%;
		float: right;
		text-align: right;
		position: absolute;
		bottom: 0;
		right: -5%;
		z-index: 222;
	}

	.intro-animation img {
		display: block;
		margin: auto;
		max-width: 100%;
		opacity: 0;
		animation: .8s ease-out 0s 1 slideInFromBottom;
		-webkit-animation: .8s ease-out 0s 1 slideInFromBottom;
		-webkit-animation-fill-mode: both;
		-moz-animation-fill-mode: both;
		-ms-animation-fill-mode: both;
		-o-animation-fill-mode: both;
		animation-fill-mode: both;
	}

	@keyframes slideInFromBottom {
		0% {
			transform: translateX(100%);
		}

		100% {
			transform: translateX(0);
			opacity: 1;
		}
	}

	@-webkit-keyframes slideInFromBottom {
		0% {
			-webkit-transform: translateX(100%);
		}

		100% {
			-webkit-transform: translateX(0);
			opacity: 1;
		}
	}


	/*===============================================*/
	/*  7.2 CUSTOM SECTION - ABOUT	 			 */
	/*===============================================*/
	.section__content--about {
		padding: 100px 0 0 0;
	}

	.grid--about .grid__item {
		margin-bottom: 0px;
	}

	.grid--about .grid__item--floated-right {
		margin-left: 80px;
	}

	.grid--about .grid__title {
		font-size: 36px;
		line-height: 42px;
		font-weight: 300;
		padding: 0 0 40px 0;
		margin: 0px;
		position: relative;
	}

	.grid--about .grid__text {
		font-size: 18px;
		color: #848484;
		line-height: 26px;
	}

	.grid--about .grid__list {
		padding: 20px 0 0 0;
	}

	.grid--about .grid__list li {
		font-size: 18px;
		padding: 10px 0 10px 40px;
	}

	.footer {
		width: 100%;
		height: auto;
		float: left;
		clear: both;
		color: #FFF;
		background-color: rgba(53,54,144, 1);
		position: relative;
	}

	/* ELEMENT - footer__content */
	.footer__content {
		clear: both;
	}

	/* ELEMENT MODIFIER footer__content  */
	.footer__content--fix-width {
		width: 1240px;
		margin: auto;
		clear: both;
	}

	.footer__content--fluid-width {
		width: 80%;
		margin: auto;
		clear: both;
	}

	.footer__content--padding {
		padding: 100px 0;
	}

	.footer__content--svg {
		padding-top: 50px;
	}

	.grid__title--footer-logo {
		font-size: 18px;
		letter-spacing: 1px;
		font-weight: 700;
	}

	.grid__title--footer-logo span {
		font-weight: 700;
	}

	.grid__title--footer {
		font-size: 20px;
		font-weight: 700;
	}

	.grid__text--copyright {
		color: #838383;
		line-height: 22px;
	}

	ul.grid__list--sicons {
		margin: 20px 0 0 0;
	}

	ul.grid__list--sicons li {
		display: inline-block;
		margin: 0 20px 0 0;
	}

	ul.grid__list--sicons li a {
		-webkit-transition: all 0.3s;
		-moz-transition: all 0.3s;
		transition: all 0.3s;
	}

	ul.grid__list--sicons li a img {
		display: block;
		width: 25px;
	}

	ul.grid__list--sicons li a:hover {
		opacity: .5;
	}

	ul.grid__list--fmenu li a {
		display: inline-block;
		color: #838383;
		text-decoration: none;
	}

	ul.grid__list--fmenu li a::after {
		content: '';
		display: block;
		width: 0;
		height: 1px;
		background: #199d48;
		transition: width .3s;
	}

	ul.grid__list--fmenu li a:hover::after {
		width: 100%;
	}

	ul.grid__list--fmenu li a:hover {
		color: #199d48;
	}

	@media screen and (max-width: 1400px) {

		.intro {
			width: 50%;
		}

	}

	/*===============================================*/
	/*Tablets and Mobile - Portrait - max 1024 px */
	/*===============================================*/
	@media screen and (max-width: 1024px) {
		body {
			font-size: 14px;
		}

		p {
			line-height: 22px;
		}


		/*       SECTION 	   */
		/*=====================*/
		.section--page-top {
			padding-top: 40px;
		}

		.section--page-bottom {
			padding-bottom: 40px;
		}

		.section__content--padding {
			padding: 50px 0;
		}

		.section__title {
			font-size: 28px;
		}

		.section__description {
			font-size: 14px;
			line-height: 26px;
		}

		.section__description--centered {
			width: 80%;
			padding: 0 0 40px 0;
		}

		/*       GRID 	   */
		/*=====================*/

		.grid--2col .grid__item,
		.grid--3col .grid__item,
		.grid--4col .grid__item,
		.grid--5col .grid__item,
		.grid--6col .grid__item {
			margin-right: 0px;
			margin-bottom: 40px;
			width: 100%;
		}

		.grid--3col .grid__item--x2,
		.grid--4col .grid__item--x3,
		.grid--5col .grid__item--x2,
		.grid--5col .grid__item--x3,
		.grid--5col .grid__item--x4,
		.grid--6col .grid__item--x2,
		.grid--6col .grid__item--x3,
		.grid--6col .grid__item--x4,
		.grid--6col .grid__item--x5 {
			width: 100%;
		}

		.grid--2col .grid__item--padding,
		.grid--3col .grid__item.grid__item--padding,
		.grid--3col .grid__item--x2.grid__item--padding,
		.grid--4col .grid__item.grid__item--padding,
		.grid--4col .grid__item--x3.grid__item--padding,
		.grid--5col .grid__item.grid__item--padding,
		.grid--5col .grid__item--x2.grid__item--padding,
		.grid--5col .grid__item--x3.grid__item--padding,
		.grid--5col .grid__item--x4.grid__item--padding,
		.grid--6col .grid__item.grid__item--padding,
		.grid--6col .grid__item--x2.grid__item--padding,
		.grid--6col .grid__item--x3.grid__item--padding,
		.grid--6col .grid__item--x4.grid__item--padding,
		.grid--6col .grid__item--x5.grid__item--padding {
			width: calc(100% - 20px * 2);
			padding: 20px;
		}

		.grid__title {
			font-size: 18px;
		}

		.grid__text {
			padding-bottom: 20px;
			line-height: 22px;
		}

		/*       FOOTER 	   */
		/*=====================*/
		.footer__content {
			padding-top: 50px;
		}

		ul.grid__list--fmenu li {
			display: block;
			float: left;
			margin: 0 20px 10px 0;
		}

		/*  INTRO 	 */
		/*---------------*/
		.intro {
			width: 100%;
			padding: 20% 0 0 0;
		}

		.intro__title {
			padding: 0 0 40px 0;
			font-size: 48px;
			line-height: 80px;
			text-align: center;
		}

		.intro__subtitle {
			font-size: 28px;
			line-height: 42px;
			padding: 0 15% 20px 15%;
			text-align: center;
		}

		.intro__description {
			font-size: 20px;
			padding: 0 0 40px 0;
			text-align: center;
		}

		.intro__buttons--left {
			text-align: center;
		}

		.intro__buttons {
			padding: 40px 0 0 0;
		}

		.intro-animation {
			width: 90%;
			height: 35%;
			float: left;
			text-align: right;
			position: absolute;
			bottom: 0;
			left: 5%;
			z-index: 222;
		}

		.intro-animation img {
			max-width: 100%;
		}

		svg.svg-intro-bottom {
			height: 20%;
		}

		svg.svg-intro-bottom-2 {
			height: 35%;
		}

		/*  ABOUT 	 */
		/*---------------*/
		.section__content--about {
			padding: 30px 0;
		}

		.grid--about .grid__item {
			margin-bottom: 30px;
		}

		.grid--about .grid__title {
			font-size: 28px;
			line-height: 36px;
		}

		.grid--about .grid__text {
			font-size: 16px;
			line-height: 24px;
		}
	}

	/*===============================================*/
	/* Tablets Landscape */
	/*===============================================*/
	@media screen and (max-width: 1024px) and (orientation: landscape) {

		/*  INTRO 	 */
		/*---------------*/
		.intro {
			padding: 12% 0 0 0;
		}

		.intro__title {
			font-size: 50px;
			line-height: 58px;
		}

		.intro__subtitle {
			font-size: 20px;
			line-height: 24px;
			padding: 0 5% 20px 5%;
		}
	}

	/*===============================================*/
	/* Mobile  800	  					 */
	/*===============================================*/
	@media screen and (max-width: 800px) {
		.intro {
			padding: 60% 0 0 0;
		}

		.header__logo-title {
			font-size: 20px;
		}

		.intro__title {
			font-size: 48px;
			line-height: 68px;
		}

		.intro__subtitle {
			font-size: 22px;
			padding: 0 15% 20px 15%;
			line-height: 28px;
		}

		.intro__description {
			font-size: 16px;
			padding: 0 0 20px 0;
		}

	}

	/*===============================================*/
	/* Mobile Landscape max  800  					 */
	/*===============================================*/
	@media screen and (max-width: 800px) and (orientation: landscape) {
		.intro {
			padding: 10% 0 0 0;
		}

		.intro__title {
			font-size: 30px;
			line-height: 50px;
			padding: 0 0 10px 0;
		}

		.intro__subtitle {
			font-size: 16px;
			padding: 0 5% 10px 5%;
			line-height: 22px;
		}

		.intro__description {
			font-size: 12px;
			padding: 0;
		}
	}

	/*===============================================*/
	/* Smaller Mobile  680	  					 */
	/*===============================================*/
	@media screen and (max-width: 680px) {
		.intro__title {
			font-size: 30px;
			line-height: 50px;
			padding: 0 0 20px 0;
		}

		.intro__subtitle {
			font-size: 16px;
			padding: 0 5% 10px 5%;
			line-height: 32px;
		}

		.intro__description {
			font-size: 12px;
			padding: 0;
		}

		.btn {
			padding: 8px 15px;
			margin: 0 5px;
		}

		.btn--play {
			padding-right: 40px;
		}
	}

	/*===============================================*/
	/* Smaller Mobile Portrait max  680	  					 */
	/*===============================================*/
	@media screen and (max-width: 680px) and (orientation: landscape) {
		.intro {
			padding: 10% 0 0 0;
		}

		.intro__title {
			font-size: 24px;
			line-height: 28px;
			padding: 0 0 5px 0;
		}

		.intro__subtitle {
			font-size: 14px;
			padding: 0 2% 5px 2%;
			line-height: 18px;
		}

	}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue